// Options Actions
export const FETCH_CUSTOM_FIELD_REQUEST = "FETCH_CUSTOM_FIELD_REQUEST";
export const FETCH_CUSTOM_FIELD_SUCCESS = "FETCH_CUSTOM_FIELD_SUCCESS";
export const FETCH_CUSTOM_FIELD_ERROR = "FETCH_CUSTOM_FIELD_ERROR";

export const FETCH_SUPPLIER_CUSTOM_FIELD_REQUEST = "FETCH_SUPPLIER_CUSTOM_FIELD_REQUEST";
export const FETCH_SUPPLIER_CUSTOM_FIELD_SUCCESS = "FETCH_SUPPLIER_CUSTOM_FIELD_SUCCESS";
export const FETCH_SUPPLIER_CUSTOM_FIELD_ERROR = "FETCH_SUPPLIER_CUSTOM_FIELD_ERROR";
